import { logEvent } from "firebase/analytics"
import { useEffect, useRef, useState } from "react"
import { analytics } from "../services/Firebase"
import { useTranslation } from "react-i18next"
import { MessageCircle } from "lucide-react"

const FeedbackPopup = () => {
    const [isOpen, setIsOpen] = useState(false)
    const popupRef = useRef(null)
    const { t } = useTranslation()

    const FEEDBACK_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSccjLKi7Z5IkROuz0YjRhtPa2elhfSH4PhZbTxVlaXPW7jinw/viewform'

    const handleBubbleClick = () => {
        if (isOpen) {
            setIsOpen(false)
        } else {
            setIsOpen(true)
        }
    }

    const handleLinkClick = () => {
        logEvent(analytics, 'feedback_bottom_click')
        window.open(FEEDBACK_URL, '_blank');
    }

    const handleClose = () => {
        setIsOpen(false)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                popupRef.current &&
                !popupRef.current.contains(event.target)
            ) {
                setIsOpen(false)
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [isOpen])

    return (
        <div className="chat-bubble-container">
            {isOpen && (
                <div className="chat-popup" ref={popupRef}>
                    <button className="close-button" onClick={handleClose}>×</button>
                    <p onClick={handleLinkClick} className="chat-message">
                        {t('haveSuggestion')}
                        <br />
                        <strong className="chat-message-sent">{t('submitHere')}</strong>
                    </p>
                </div>
            )}
            <div className="chat-icon" onClick={handleBubbleClick}>
                    <MessageCircle className="chat-feedback-icon" />
            </div>
        </div>
    )
}

export default FeedbackPopup;
